<template>
	<el-dialog :title="type==0?'发起拼团':'添加参团人'" :visible.sync="visible" :before-close='startGroupStateClose' width="600px" :close-on-click-modal="false">
		<div class="com">
			<div class="mr">参团人数:</div>
			<div>{{group.people?group.people:group.group_book_goods_info.people}}人团</div>
		</div>
		<div class="com">
			<div class="mr">头像:</div>
			<el-upload class="avatar-uploader" action="https://res.huashengchongwu.com/api/media/oss/upload?dir='memberImg'"
				:show-file-list="false" :http-request="uploadImg">
				<img v-if="avatar_pic" :src="avatar_pic" class="avatar">
				<i v-else class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
		</div>
		<div class="com">
			<div class="mr">用户名称:</div>
			<el-input placeholder="请输入用户名称" v-model="user_name" clearable style="width: 200px;" size="small">
			</el-input>
		</div>
		<div class="com">
			<div class="mr">手机号:</div>
			<el-input placeholder="请输入手机号" v-model="mobile" clearable style="width: 200px;" size="small">
			</el-input>
		</div>
		<div style="text-align: center;">
			<el-button type="primary" @click="handelSubmitClick">确认发起</el-button>
		</div>
	</el-dialog>
</template>
<script>
	import {
		uploadImg
	} from '../api/stockApi.js'
	import {
		createVirtualGroupBookList,
		createVirtualJoinGroupBookList
	} from '../api/program.js'
	export default {
		props: {
			startGroupState: { //显示状态
				default: false
			},
			group: {
				default:null
			},
			type:{
				default:0
			}
		},
		data() {
			return {
				visible: true,
				avatar_pic:'',
				user_name:'',
				mobile:'',
			};
		},
		mounted() {
			console.log(this.group,this.type)
		},
		methods: {
			//发起拼团
			handelSubmitClick(){
				if(this.user_name == ''){
					this.$message({
						type: 'error',
						message: '请输入用户名称'
					});
					return
				}
				if(this.mobile == ''){
					this.$message({
						type: 'error',
						message: '请输入手机号'
					});
					return
				}
				if(this.avatar_pic == ''){
					this.$message({
						type: 'error',
						message: '请输入用户头像'
					});
					return
				}
				if(this.type == 0){
					let params = {
						group_book_id:this.group._id,
						item_id:this.group.goods_list[0].item_id,
						user_name:this.user_name,
						mobile:this.mobile,
						avatar_pic:this.avatar_pic
					}
					createVirtualGroupBookList(params).then((res)=>{
						if(res.code == 0){
							this.$message({
								type: 'success',
								message: '已发起'
							});
							this.$emit("closeOn", false);
						}
					})
				}else{
					console.log('添加参团人')
					let params = {
						group_book_id:this.group.group_book_goods_info.group_book_id,
						item_id:this.group.order_list[0].goods_item.item_id,
						group_book_list_id:this.group._id,
						user_name:this.user_name,
						mobile:this.mobile,
						avatar_pic:this.avatar_pic
					}
					createVirtualJoinGroupBookList(params).then((res)=>{
						if(res.code == 0){
							this.$message({
								type: 'success',
								message: '已添加'
							});
							this.$emit("closeDialog", false);
						}
					})
				}
				
			},
			//上传头像
			uploadImg(item) {
				var formData = new FormData();
				formData.append('img', item.file);
				uploadImg(formData).then(res => {
					if (res.code == 0) {
						this.avatar_pic = res.data.url;
					}
				})
			},
			//向父组件发射关闭弹框
			startGroupStateClose(done) {
				done()
				this.$emit("closeOn", false);
			},
		},
		watch: {
			// 监视状态发生改变
			startGroupState() {
				this.visible = this.startGroupState;
			},
		}
	};
</script>
<style lang="scss">
	.mr {
		width: 80px;
	}
	.com {
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}
	
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}
	
	.avatar {
		width: 80px;
		height: 80px;
		display: block;
		object-fit: cover;
	}
</style>
